
import customStyles from "../../../../assets/styles/customStyles";
import clsx from "clsx";

export const SelectedIcon = (props) => {
    const classes = customStyles();
    return (
        <span className={classes.selectedIcon}></span>
    )
};



export const UnSelectedIcon = (props) => {
    const classes = customStyles();
    return (
        <span className={clsx(classes.selectedIcon, classes.unSelectedIcon)}></span>
    )
};

